export default __webpack_public_path__ + "media/brands/adobe-da1601a7.png";